// SECURITY: every publicly-reachable production hostname MUST be listed here.
// A missing prod domain means isLiveHost() returns false there, which SKIPS the
// waitlist/approval routing in Auth.tsx — opening uncontrolled public signups.
// `adventureventure.app` is the canonical prod domain (see usePageMeta.ts).
const LIVE_HOSTS = new Set([
  "adventureventure.app",
  "www.adventureventure.app",
  "adventure-venture.lovable.app",
  "advanture-venture.8scope.com",
]);

/** True when running on a publicly-published host where new signups must be
 *  routed to the email-capture waitlist instead of the normal auth flow. */
export function isLiveHost(): boolean {
  if (typeof window === "undefined") return false;
  return LIVE_HOSTS.has(window.location.hostname);
}